
class Sys {
  static wait(ms) {
    return new Promise(r => setTimeout(r, ms));
  }
}

export default Sys;
